module.exports = __webpack_public_path__ + "files/e34fa0d5df02b0319ef855178e6b0f1e.png";